/* eslint-disable @typescript-eslint/no-var-requires */
const dayjs = require("dayjs");
require("dayjs/locale/nb");
const {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
} = require("./src/constants/language-and-locales");
const { getDayJSLocale } = require("./src/utils/functions.js");
const { getLocaleParts } = require("./src/utils/localisation-utils.js");

function isTimestamp(n) {
  const nString = typeof n === "number" ? n.toString() : n;
  const nFloat = typeof n === "number" ? n : parseFloat(n);
  return (
    !Number.isNaN(nFloat) &&
    Number.isFinite(nFloat) &&
    /^\d+\.?\d+$/.test(nString)
  );
}

function isDate(testString) {
  const dateParsed = Date.parse(testString);
  return isTimestamp(dateParsed);
}

module.exports = {
  reloadOnPrerender: process.env.NODE_ENV === "development",
  serializeConfig: false,
  interpolation: {
    format: function (value, format, locale) {
      const lang = getLocaleParts(locale).lang;

      if (value instanceof Date || isDate(value) || isTimestamp(value)) {
        return dayjs(value).locale(getDayJSLocale(lang)).format(format);
      }
      return value;
    },
  },
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: SUPPORTED_LOCALES,
  },
  localeDetection: process.env.NODE_ENV !== "development",
  localePath: require("path").resolve("./src/i18n/locales"), // https://github.com/i18next/next-i18next/issues/1552#issuecomment-981156476
  fallbackLng: {
    "en-NO": ["en"],
    "no-NO": ["no"],
  },
};
